

















import VueI18n from 'vue-i18n';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { TextRuleType } from '@/components/atoms/neon/CustomTextField.vue';

@Component
export default class TextField extends Vue {
  @Prop({ required: false, default: '' })
  private sampleInput!: string;

  @Prop({ required: false, default: false })
  private isRequired!: boolean;

  @Prop()
  private value!: string;

  @Prop()
  private prefix!: string;

  @Prop()
  private rules!: TextRuleType[];

  @Prop()
  private errorMessage!: VueI18n.TranslateResult;

  @Prop({ required: false, default: 'text' })
  private type!: string;

  @Emit('changeInText')
  private changeInText(value: string): string {
    return value || '';
  }

  private isVisible: boolean = false;

  private get errorMessages(): VueI18n.TranslateResult {
    return this.errorMessage;
  }

  private get isPasswordInput() {
    return this.type === 'password';
  }

  private get visibilityIcon() {
    return this.isVisible ? 'mdi-eye-off' : 'mdi-eye';
  }

  private get visibilityInputType() {
    return this.isVisible ? 'text' : 'password';
  }
}
